import { useState } from "react";
import { Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import { currencyFormat } from "../../../helpers/numericFields";
import styles from './AgencyPaymentSchemeDetails.module.css'
import { EditPayment } from "./EditPayment";

export const PaymentScheduleDetails = ({ groupFile }) => {
  const { role } = useSelector((state) => state.auth);
  const { paymentSchedule } = useSelector((state) => state.groupFiles);
  const [editPaymentSchedule2, setEditPaymentSchedule2] = useState(false);
  const [paymentSelected, setPaymentSelected] = useState({});


  const edit2 = (payment) => {
    setEditPaymentSchedule2(true);
    setPaymentSelected(payment);
  }

  return (
    <div style={{ marginTop: 20, marginBottom: 50, border: "1 solid gray", background: "white", padding: 20 }}>
      <div className="table-responsive">
        <Table className="table border text-nowrap mg-b-0">
          <thead>
            <tr>
              <th>#</th>
              <th>Concepto</th>
              <th>Descripción</th>
              <th>Cantidad</th>
              <th>Fecha</th>
              <th>Notas</th>
              <th>Editar</th>
            </tr>
          </thead>
          <tbody>
            {
              paymentSchedule.map((payment, index) => (
                <tr key={payment.id}>
                  <td>{index + 1}</td>
                  <td>{payment.concept}</td>
                  <td>{payment.description}</td>
                  <td>{currencyFormat(payment.amount)}</td>
                  <td className="break-word ">{payment.date}</td>
                  <td>{payment.notes}</td>
                  {
                    role === "DIRECTOR"
                    && <td style={{ textAlign: "center" }}>
                      <i className={`fe fe-edit ${styles.edit}`} onClick={() => edit2(payment)}></i>
                    </td>
                  }
                </tr>))
            }
          </tbody>
        </Table>
      </div>

      <EditPayment payment={paymentSelected} groupFile={groupFile}
        isOpen={editPaymentSchedule2} setIsOpen={setEditPaymentSchedule2} />
    </div>
  )
}
